/* RESPONSIBLE TEAM: team-inbox-experience */
import {
  VALID_ACTION_TYPES,
  AWAY_MODE_KEY,
  REPORTS_DELETE_KEY,
  CHANGE_TICKET_TYPE_KEY,
} from 'embercom/lib/settings/permissions/constants';

export default function isActionPermission(permissionKey) {
  if (permissionKey === AWAY_MODE_KEY || permissionKey === REPORTS_DELETE_KEY) {
    return false;
  }

  // Exclude macro permissions - they're hierarchical but not action-based
  if (
    permissionKey === 'can_create_macros' ||
    permissionKey === 'can_edit_macros' ||
    permissionKey === 'can_delete_macros'
  ) {
    return false;
  }

  // Exclude permissions whose key contains action words but aren't action-based
  if (permissionKey === CHANGE_TICKET_TYPE_KEY) {
    return false;
  }

  return VALID_ACTION_TYPES.some((action) => permissionKey.includes(action));
}
